export default "__VITE_ASSET__CbaP1M81__"